import styled from '@emotion/styled';
import {colors} from 'ui/config';
import Slider from 'react-slick';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: colors.white,
  paddingLeft: 20,
  paddingRight: 20,
  paddingTop: 15,
  paddingBottom: 36,
});

export const Slides = styled(Slider)({
  marginTop: 30,
  // marginLeft: -20,
  width: '100vw',
});
